import React from 'react';
import { ExamScoringSchema, ExamTask } from '../../models/assessment.types';
import { Prompt } from '../Prompt/Prompt.component';

interface GradeChangePromptProps {
  open: boolean;
  activeTask: ExamTask;
  activeCriterion: ExamScoringSchema | null;
  onCancel?: () => void;
  onConfirm?: () => void;
}

const GradeChangePrompt: React.FC<GradeChangePromptProps> = (props) => {
  return (
    <Prompt
      type="confirmation"
      open={props.open}
      size="xs"
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
      mainActionButtonText="TAK"
      mainText={
        <>
          Czy na pewno chcesz wprowadzić <br /> zmiany w punktacji dla:{' '}
          {props.activeTask.taskNumber && !props.activeCriterion && <> Zadanie {props.activeTask.taskNumber} </>}
        </>
      }
      subTexts={[
        {
          text: props.activeCriterion && (
            <>
              Kryterium: {props.activeCriterion ? props.activeCriterion.criterionName : null} (Zadanie{' '}
              {props.activeTask.taskNumber})
            </>
          ),
        },
      ]}
    />
  );
};

export default GradeChangePrompt;
